import React from 'react';
import { ChevronRight } from 'lucide-react';

interface MenuItem {
    icon: any;
    label: string;
    subLabel?: string;
    onClick?: () => void;
    href?: string;
    danger?: boolean;
}

interface MenuSectionProps {
    title: string;
    items: MenuItem[];
}

export const MenuSection: React.FC<MenuSectionProps> = React.memo(({ title, items }) => {
    return (
        <div className="mb-8">
            <h3 className="px-6 text-[11px] font-black text-slate-400 mb-2 uppercase tracking-[0.2em]">{title}</h3>
            <div className="bg-white border-y border-gray-50 overflow-hidden">
                {items.map((item, idx) => {
                    const isExternal = item.href?.startsWith('http');
                    const isInternalLink = item.href?.startsWith('/');
                    
                    const handleClick = () => {
                        if (isInternalLink) {
                            window.navigateTo(item.href!);
                        } else if (isExternal) {
                            window.open(item.href, '_blank');
                        } else if (item.onClick) {
                            item.onClick();
                        }
                    };

                    return (
                        <button 
                            key={idx}
                            onClick={handleClick}
                            className={`w-full flex items-center justify-between p-5 md:hover:bg-gray-50 transition-all text-left group ${idx !== items.length - 1 ? 'border-b border-gray-100' : ''}`}
                        >
                            <div className="flex items-center gap-5">
                                <div className={`w-10 h-10 rounded-xl flex items-center justify-center transition-colors ${item.danger ? 'bg-rose-50 text-rose-500' : 'bg-slate-50 text-slate-400 md:group-hover:text-rose-500 md:group-hover:bg-rose-50'}`}>
                                    <item.icon size={22} />
                                </div>
                                <div className="flex flex-col">
                                    <span className={`text-base font-bold ${item.danger ? 'text-rose-500' : 'text-slate-900'}`}>{item.label}</span>
                                    {item.subLabel && <span className="text-xs text-slate-400 font-medium">{item.subLabel}</span>}
                                </div>
                            </div>
                            <ChevronRight size={18} className="text-slate-200 md:group-hover:text-rose-400 transition-all" />
                        </button>
                    );
                })}
            </div>
        </div>
    );
});

MenuSection.displayName = 'MenuSection';
